<template>
	<BaseWebshopCartPreview v-slot="{parcels, cartUrl}">
	<div class="ww-preview shopping_cart_preview">
		<div class="shoppingcart_items_small clear" v-if="parcels[0]?.items?.length">
			<div class="ww-preview-items shopping_cart_preview_items">
				<table class="ww-preview-table">
					<tbody>
						<WebshopCartItemSmall :mode="mode" v-for="item in parcels[0].items" :data="item" :key="item.shopping_cart_code" />
					</tbody>
				</table>
			</div>
			<div class="ww-buttons-delivery-cnt">
				<BaseCmsLabel code="w_benefit_delivery" class="ww-fast-delivery" tag="div" />
				<div class="ww-totals">
					<BaseWebshopTotal v-slot="{items}">
						<template v-if="items">
							<div class="ww-total cart_info_total_extra_loyalty_box ww-loyalty-box" v-if="items.total_extra_loyalty">
								<span class="ww-totals-label">
									<BaseCmsLabel code="loyalty" default="Kartica kupca" />
									<span class="cart_info_total_extra_loyalty_discount_percent">{{' '+items.total_extra_loyalty_discount_percent }}</span>%:
								</span>
								<span class="ww-totals-value cart_info_total_extra_loyalty"><BaseUtilsFormatCurrency :price="items.total_extra_loyalty" /></span>
							</div>
							<div class="ww-discount cart_info_total_extra_discount_box" v-if="items.total_extra_discount">
								<span class="ww-totals-label"><BaseCmsLabel code="discount" default="Popust" />:</span>
								<span class="ww-totals-value cart_info_total_extra_discount"><BaseUtilsFormatCurrency :price="items.total_extra_discount" /></span>
							</div>
							<div class="ww-total ww-total-shipping">
								<span class="ww-totals-label"><BaseCmsLabel code="shipping" default="Dostava" />:</span>
								<span class="ww-totals-value cart_info_total_extra_shipping">
									<template v-if="items.total_extra_shipping == 0">
										<BaseCmsLabel code="free" class="w-totals-label-free" tag="span" />
									</template>
									<template v-else>
										<BaseUtilsFormatCurrency :price="items.total_extra_shipping" />
									</template>
								</span>
							</div>
							<div class="ww-total ww-total-sum" v-if="items.total">
								<span class="ww-totals-label"><BaseCmsLabel code="total" default="Ukupno za platiti" />:</span>
								<span class="ww-totals-value cart_info_total total_price"><BaseUtilsFormatCurrency :price="items.total" /></span>
							</div>
						</template>
					</BaseWebshopTotal>
				</div>
			</div>

			<div class="ww-buttons">
				<NuxtLink :to="cartUrl" class="btn btn-secondary ww-btn-view">
					<span><BaseCmsLabel code="view_shopping_cart" /></span>
				</NuxtLink>
				<BaseUtilsAppUrls v-slot="{items}">
					<NuxtLink :to="items.webshop_customer" class="btn btn-primary ww-btn-finish cart-finish-shopping">
						<span><BaseCmsLabel code="finish_shopping" /></span>
					</NuxtLink> 		
				</BaseUtilsAppUrls>
			</div>

			<BaseWebshopFreeShipping v-slot="{item}">
				<div class="ww-preview-note-cnt cart_info_total_extra_shipping_to_free_box" v-show="item?.amount != 0">
					<div class="ww-preview-note cart_info_total_extra_shipping_to_free_box">
						<div class="free-delivery"><BaseCmsLabel code="min_total_missing" tag="span" /> <strong class="w-missing-shipping-value cart_info_total_extra_shipping_to_free"><BaseUtilsFormatCurrency :price="item.amount" /></strong></div>
					</div>

					<div class="free-delivery-missing sc-free-delivery-missing cart_info_total_extra_shipping_to_free_box" v-show="item.amount != 0">
						<div class="free-delivery-missing-bg-cnt">
							<span class="free-delivery-missing-bg cart_info_total_extra_shipping_to_free_percent" :style="'width: '+item.percent"></span>
						</div>
						<span class="free-delivery-missing-overlay"></span>
					</div>
				</div>
			</BaseWebshopFreeShipping>
		</div>
	</div>
	</BaseWebshopCartPreview>
</template>

<script setup>
	const labels = useLabels();
	const props = defineProps({
		mode: String,
		onClose: Function,
	});
</script>

<style lang="less" scoped>
	.ww-preview{
		position: absolute; width: 500px; right: 0; top: 50px;  background: white; color: var(--textColor); box-shadow: 0 10px 30px 0 rgba(85,41,122,0.28); z-index: 99999; /*display: block!important;*/
		.free-delivery{color: var(--primaryColor) !important}
		.w-totals-label-free{font-weight: 600;}
		&:before{.pseudo(6px,6px); transform: rotate(45deg); background: white; top: -3px; right: 21px;}
		.w-totals-delivery{padding: 0 30px 25px 30px;
			:deep(p){text-align: center;}
		}
		@media (max-width: @l){top: 44px;}
		@media (max-width: @t){display: none !important;}
	}
	.ww-totals{width: 55%; padding-left: 10px; font-size: 15px; line-height: 1.3; font-weight: normal;}
	.ww-total{display: flex; padding: 1px 0;justify-content: space-between;}
	.ww-totals-label{flex-grow: 1;}
	.ww-totals-value{width: auto; flex-grow: 0; flex-shrink: 0; text-align: right;}
	.ww-total-sum{font-weight: bold;}

	.ww-minprice{ margin-top: 0 !important; margin-bottom: 10px; margin: 10px 20px 5px 20px !important;}
	.ww-preview-items{max-height: 360px; overflow: auto;}

	.ww-buttons{
		display: flex; justify-content: space-between; padding: 0 20px 20px;
		.btn{ min-width: 225px; width: 225px; height: 60px; min-height: 60px; font-size: 18px; line-height: 24px; display: inline-flex; justify-content: center; align-items: center; background: white; border: 1px solid var(--primaryColor); color: var(--primaryColor); margin-bottom: 0; margin-right: 10px;
			@media(min-width: @h){
				&:hover{ background: #4D256F; color: white; border: 1px solid var(--primaryColor);}
			}
		}
	}
	.ww-buttons-delivery-cnt{display: flex; align-items: center; padding: 15px 20px; justify-content: space-between;}
	.ww-fast-delivery{
		font-size: 14px; line-height: 18px; color: var(--textColor);position: relative; padding-left: 65px; width: 45%;
		&:before{.icon-delivery; font: 32px/32px var(--fonti); position: absolute; display: block; left: 0;  top: 4px; color: var(--primaryColor); }
		:deep(span){font-size: 18px!important; font-weight: normal; line-height: 22px !important; color: var(--primaryColor); display: block;}
	}
	.ww-btn-finish{background: var(--primaryColor) !important; color: white !important; font-style: normal; margin-right: 0 !important; border: 1px solid var(--primaryColor) !important;
		@media(min-width: @h){
			&:hover{background: #4D256F !important;}
		}
	}
	.ww-btn-finish{&:hover{color: white; background: #472266;}}
	.ww-preview-table{width: 100%; border-bottom: 1px solid var(--borderColor); margin-top: 2px;
		:deep(td){vertical-align: top; padding: 0;}
		:deep(tr){
			width: 100%; max-width: 100%; display: block; position: relative; border-bottom: 1px solid var(--borderColor); padding: 10px 20px 10px 20px;
			&:nth-last-child(1){ border: none;}
		}
	}
	.ww-preview-note-cnt{padding: 0 20px 20px;
		.free-delivery{padding-top: 0; font-size: 18px; text-align: center; background: transparent; text-transform: unset; min-height: unset; line-height: 24px; display: block; padding: 0 0 13px 0; font-weight: 300;}
		.free-delivery-missing-bg-cnt{margin-right: 63px;}
		.free-delivery-missing-overlay{right: 79px;}
	}
	.w-totals-label-free{font-weight: bold;}
</style>
